import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { MarkdownPageContext } from "@utils/MarkdownUtils";
import classnames from "classnames";

const ClientsSection = ({
  title = "",
  curves = true,
  showTitle = true,
}: {
  title?: string;
  curves?: boolean;
  showTitle?: boolean;
}) => {
  const data = useStaticQuery(graphql`
    query ClientsSectionData {
      strapiImage(collectionName: { eq: "clientCloud" }) {
        images {
          id
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(
                height: 70
                placeholder: NONE
                transformOptions: { grayscale: true }
              )
            }
          }
        }
      }
    }
  `);
  return (
    <div
      className={classnames("div-block mt-10 md:mt-0 md:pt-16 md:pb-20", {
        "faded-curves": curves,
      })}
    >
      <div className="max-w-full">
        <div className="flex flex-col text-center">
          {showTitle && (
            <div id="join_clients" className="text-center text-white">
              <MarkdownPageContext>{title}</MarkdownPageContext>
            </div>
          )}
          {/* Logos */}
          <div className="mt-5 grid grid-cols-2 pb-8 md:mt-8 md:grid-cols-3 xl:grid-cols-6 xl:gap-8">
            {data.strapiImage.images.map(clientImage => (
              <div
                key={clientImage.id}
                className="flex items-center justify-center"
              >
                <GatsbyImage
                  image={clientImage.localFile.childImageSharp.gatsbyImageData}
                  className="my-4 mx-4 max-h-12 max-w-[145px]"
                  alt={clientImage.alternativeText}
                  imgStyle={{ objectFit: "contain" }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsSection;
